/**
 * Daylight — a LIGHT theme: dark text on a soft light background. None of the
 * other themes cover bright rooms / projector glare, where dark-on-light reads
 * far better. Glow is removed (it only reads on dark); panels are near-opaque
 * white so text stays high-contrast over any background image.
 *
 * Note: the app mounts MantineProvider with defaultColorScheme="dark"; this
 * theme overrides the surface colors via cssVars rather than flipping Mantine's
 * scheme, which keeps component theming consistent across all themes.
 */
export const daylight = {
  id: 'daylight',
  name: 'Daylight',
  assignable: true,
  // Light surface scheme — the resolver flips MantineProvider to "light" so
  // component defaults (Paper, dimmed text, inputs) match the light background.
  colorScheme: 'light',
  mantine: {
    primaryColor: 'blue',
    fontFamily: 'Inter, system-ui, sans-serif',
    headings: { fontFamily: 'Inter, system-ui, sans-serif' },
  },
  cssVars: {
    '--bw-bg': 'linear-gradient(180deg, #eef2f7 0%, #dfe6ef 100%)',
    '--bw-body-color': '#1a2230',
    '--bw-panel-bg': 'rgba(255, 255, 255, 0.95)',
    '--bw-panel-border': 'rgba(40, 70, 120, 0.18)',
    '--bw-accent': 'rgba(30, 90, 170, 1)',
    '--bw-glow-color': 'rgba(0, 0, 0, 0)',
    '--bw-glow-text-color': 'rgba(0, 0, 0, 0)',
    '--bw-body-font': "'Inter', system-ui, sans-serif",
    '--bw-heading-font': "'Inter', system-ui, sans-serif",
    '--bw-heading-letter-spacing': '0.01em',
    '--bw-content-base': '1.0625rem',
  },
}
